/* eslint-disable */
export default {
      "seo_texts@seo_tags/twitter_app_name": 0,
      "signin@PHONE_INCORRECT": 1,
      "badoo_safety_center@footer.cta.get_the_app": 2,
      "badoo_homepage@button.apple.signup.text": 3,
      "badoo_homepage@button.facebook.signup.text": 4,
      "badoo_homepage@button.google.signup.text": 5,
      "badoo_homepage@button.login.text": 6,
      "badoo_homepage@button.signup.text": 7,
      "badoo_homepage@captcha.page.body": 8,
      "badoo_homepage@captcha.page.button_submit": 9,
      "badoo_homepage@captcha.page.field.label": 10,
      "badoo_homepage@captcha.page.title": 11,
      "badoo_homepage@captcha.reload.label": 12,
      "badoo_homepage@create_password.page.body": 13,
      "badoo_homepage@create_password.page.button_submit": 14,
      "badoo_homepage@create_password.page.confirm.field.label": 15,
      "badoo_homepage@create_password.page.password.field.hint": 16,
      "badoo_homepage@create_password.page.password.field.label": 17,
      "badoo_homepage@create_password.page.title": 18,
      "badoo_homepage@footer.blog": 19,
      "badoo_homepage@footer.careers": 20,
      "badoo_homepage@footer.chat": 21,
      "badoo_homepage@footer.cities": 22,
      "badoo_homepage@footer.cookies": 23,
      "badoo_homepage@footer.copyright": 24,
      "badoo_homepage@footer.download.copy.text": 25,
      "badoo_homepage@footer.download.title": 26,
      "badoo_homepage@footer.facebook": 27,
      "badoo_homepage@footer.follow_us.title": 28,
      "badoo_homepage@footer.help_centre": 29,
      "badoo_homepage@footer.instagram": 30,
      "badoo_homepage@footer.language.title": 31,
      "badoo_homepage@footer.linkedin": 32,
      "badoo_homepage@footer.overview": 33,
      "badoo_homepage@footer.part_of": 34,
      "badoo_homepage@footer.privacy": 35,
      "badoo_homepage@footer.safety_centre": 36,
      "badoo_homepage@footer.sitemap": 37,
      "badoo_homepage@footer.slavery_act": 38,
      "badoo_homepage@footer.terms": 39,
      "badoo_homepage@footer.twitter": 40,
      "badoo_homepage@forgot_password.page.body": 41,
      "badoo_homepage@forgot_password.page.button_submit": 42,
      "badoo_homepage@forgot_password.page.field.label": 43,
      "badoo_homepage@forgot_password.page.title": 44,
      "badoo_homepage@illustrative_purposes.label": 45,
      "badoo_homepage@landing.guide.cta.get_the_app": 46,
      "badoo_homepage@landing.guide.section.five.body": 47,
      "badoo_homepage@landing.guide.section.five.commitment.five": 48,
      "badoo_homepage@landing.guide.section.five.commitment.four": 49,
      "badoo_homepage@landing.guide.section.five.commitment.one": 50,
      "badoo_homepage@landing.guide.section.five.commitment.three": 51,
      "badoo_homepage@landing.guide.section.five.commitment.two": 52,
      "badoo_homepage@landing.guide.section.five.cta": 53,
      "badoo_homepage@landing.guide.section.five.title": 54,
      "badoo_homepage@landing.guide.section.four.body.one": 55,
      "badoo_homepage@landing.guide.section.four.body.two": 56,
      "badoo_homepage@landing.guide.section.one.body": 57,
      "badoo_homepage@landing.guide.section.one.cta": 58,
      "badoo_homepage@landing.guide.section.one.title": 59,
      "badoo_homepage@landing.guide.section.three.intro": 60,
      "badoo_homepage@landing.guide.section.three.list_item.five": 61,
      "badoo_homepage@landing.guide.section.three.list_item.four": 62,
      "badoo_homepage@landing.guide.section.three.list_item.one": 63,
      "badoo_homepage@landing.guide.section.three.list_item.three": 64,
      "badoo_homepage@landing.guide.section.three.list_item.two": 65,
      "badoo_homepage@landing.guide.section.three.title": 66,
      "badoo_homepage@landing.guide.section.two.body": 67,
      "badoo_homepage@landing.guide.section.two.body.part.two": 68,
      "badoo_homepage@landing.guide.section.two.cta": 69,
      "badoo_homepage@landing.guide.section.two.title": 70,
      "badoo_homepage@page_section.chat.body.text": 71,
      "badoo_homepage@page_section.chat.header.title": 72,
      "badoo_homepage@page_section.hero.footer.text": 73,
      "badoo_homepage@page_section.hero.header.subtitle": 74,
      "badoo_homepage@page_section.hero.header.title": 75,
      "badoo_homepage@page_section.hero.or": 76,
      "badoo_homepage@page_section.hero.separator_text": 77,
      "badoo_homepage@page_section.hero.signup_field.label": 78,
      "badoo_homepage@page_section.intention.body.text.p1": 79,
      "badoo_homepage@page_section.intention.body.text.p2": 80,
      "badoo_homepage@page_section.intention.bubble_tag.first.label": 81,
      "badoo_homepage@page_section.intention.bubble_tag.second.label": 82,
      "badoo_homepage@page_section.intention.bubble_tag.third.label": 83,
      "badoo_homepage@page_section.intention.header.title": 84,
      "badoo_homepage@page_section.intention.picture.title": 85,
      "badoo_homepage@page_section.safety.body.text.p1": 86,
      "badoo_homepage@page_section.safety.body.text.p2": 87,
      "badoo_homepage@page_section.safety.body.text.safety_centre_link": 88,
      "badoo_homepage@page_section.safety.header.title": 89,
      "badoo_homepage@page_section.stories.body.story1": 90,
      "badoo_homepage@page_section.stories.body.story2": 91,
      "badoo_homepage@page_section.stories.body.story3": 92,
      "badoo_homepage@page_section.stories.header.title": 93,
      "badoo_homepage@page_section.stories.stories_link": 94,
      "badoo_homepage@page_section.trust.apple.rating.label": 95,
      "badoo_homepage@page_section.trust.apple.store.label": 96,
      "badoo_homepage@page_section.trust.body.text": 97,
      "badoo_homepage@page_section.trust.google.downloads.label": 98,
      "badoo_homepage@page_section.trust.google.downloads.value": 99,
      "badoo_homepage@page_section.trust.google.store.label": 100,
      "badoo_homepage@page_section.trust.header.title": 101,
      "badoo_homepage@page_signin.field_login.label": 102,
      "badoo_homepage@page_signin.field_password.label": 103,
      "badoo_homepage@page_signin.forgot_password.title": 104,
      "badoo_homepage@page_signin.signup_link": 105,
      "badoo_homepage@page_signin.subtitle": 106,
      "badoo_homepage@page_signin.title": 107,
      "badoo_homepage@page_signup.title": 108
} as const;
